module.exports = __webpack_public_path__ + "images/sparta_small89947449ea625d29275ad303897ba66e.png";